import { Button } from '@mantine/core';
import { MdUnarchive } from 'react-icons/md';
import { Message, MessagePatch, MessageStatus } from '../types';

interface UnarchiveButtonProps {
    message: Message;
    onUnarchive: (patch: MessagePatch) => void;
}

export const UnarchiveButton = ({ onUnarchive }: UnarchiveButtonProps) => {
    const handleClick = () => {
        onUnarchive({ status: MessageStatus.READ });
    };

    return (
        <Button
            leftSection={<MdUnarchive />}
            onClick={handleClick}
            variant="light"
        >
            Unarchive
        </Button>
    );
};
